import { Navigate, useParams } from 'react-router-dom';

import { ReferralRequestSurvey as ReferralRequestSurveyFeature } from '../../../features/referral-request-survey/referral-request-survey';

type ReferralRequestSurveyProps = { readonly reviewMode?: boolean };

const ReferralRequestSurvey = ({ reviewMode = false }: ReferralRequestSurveyProps) => {
  const { id } = useParams<{ id: string }>();

  if (!id) return <Navigate to="/" />;

  return <ReferralRequestSurveyFeature referralRequestId={id} reviewMode={reviewMode} />;
};

export { ReferralRequestSurvey };
